import { render, staticRenderFns } from "./advertisementedit.vue?vue&type=template&id=0cf439d4&scoped=true&"
import script from "./advertisementedit.vue?vue&type=script&lang=js&"
export * from "./advertisementedit.vue?vue&type=script&lang=js&"
import style0 from "./advertisementedit.vue?vue&type=style&index=0&id=0cf439d4&lang=stylus&scoped=true&"
import style1 from "./advertisementedit.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf439d4",
  null
  
)

component.options.__file = "advertisementedit.vue"
export default component.exports